import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { getStringDate } from 'src/app/common/util';
import { PaginationComponent } from 'src/app/components/elements/pagination/pagination.component';
import { EmployeeRequest, EmployeeResponse } from 'src/app/models/employee.model';
import { ProfileSalaryRequest } from 'src/app/models/profile-salary.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { CountryService } from 'src/app/services/country.service';
import { HumanResourcesService } from 'src/app/services/human-resources.service';
import { RolesAndPermissionsService } from 'src/app/services/roles-and-permissions.service';
import { WarehouseService } from 'src/app/services/warehouse.service';

@Component({
  selector: 'app-hiring',
  templateUrl: './hiring.component.html',
  styleUrls: ['./hiring.component.scss']
})
export class HiringComponent implements OnInit {
  newEmployee: EmployeeRequest = null;
  selectedProfile = null;
  selectedPosition = null;
  countries = [];
  warehouses = [];
  positions = [];
  contractProfiles = [];
  citizenships = [];
  departments = [];
  towns = [];
  areas = [];
  create = false;
  personalToHire: EmployeeResponse[] = [];
  personalHiring: { [key: number]: any } = {};
  hiring = false;
  pagination = {
    total: [],
    filter: [],
    pageSize: 5,
    startElement: 0,
    lastElement: 0,
    pageIndex: 0
  }
  createProfileSalary = false;
  newSalary: ProfileSalaryRequest = null;
  newDocuments: EmployeeResponse = null;
  contractEmployees = false;
  @ViewChild(PaginationComponent) paginationComponent: PaginationComponent;


  constructor(
    private countryService: CountryService,
    private toastService: ToastrService,
    private warehouseService: WarehouseService,
    private rrhhService: HumanResourcesService,
    private roleService: RolesAndPermissionsService
  ) {

  }

  ngOnInit(): void {
    this.setCitizenships();
    this.setCountries();
    this.setProfileContracts(null);
    this.setWarehouses();
    this.setPersonalToHire();
    this.setAreas();
    this.setAllDepartments();
    this.setAllPositions();
  }

  setAreas() {
    this.roleService.getAreas().subscribe({
      next: (response: ResponseObject) => {
        this.areas = response.data;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  setAllDepartments() {
    this.roleService.getDepartments().subscribe({
      next: (response: ResponseObject) => {
        this.departments = response.data;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }


  setAllPositions() {
    this.roleService.getPositions().subscribe({
      next: (response: ResponseObject) => {
        this.positions = response.data;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  showActualProfileSalary() {
    var findOut = this.contractProfiles.find((p) => {
      return p.id + "" == this.selectedProfile + ""
    })
    findOut['isPro'] = (findOut.proAmount) ? true : false;
    findOut['isBonus'] = (findOut.bonusAmount) ? true : false;
    findOut['isRelation'] = (findOut.relationAmount) ? true : false;
    this.createProfileSalary = false;
    this.newSalary = findOut;
  }

  setCountries() {
    this.countryService.getCountry().subscribe({
      next: (response: ResponseObject) => {
        this.countries = response.data;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  showModalHiring() {
    this.create = true;
    this.newEmployee = new EmployeeRequest();
  }

  showModalEmployee(employee:EmployeeRequest){
    this.create = false;
    this.newEmployee = employee;
    this.newEmployee.nacimiento = getStringDate(new Date(this.newEmployee.nacimiento));
    console.log(this.newEmployee);
  }

  closingModalHiring() {
    this.create = false;
    this.newEmployee = null;
    this.setPersonalToHire();
  }

  setWarehouses() {
    this.warehouseService.getWarehouses().subscribe({
      next: (response: ResponseObject) => {
        this.warehouses = response.data;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  setProfileContracts(idSelected: number) {
    this.rrhhService.getProfileContract().subscribe({
      next: (response: ResponseObject) => {
        this.contractProfiles = response.data;
        if (idSelected) {
          this.selectedProfile = idSelected;
        }
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  setCitizenships() {
    this.countryService.getCitizenship().subscribe({
      next: (response: ResponseObject) => {
        this.citizenships = response.data;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  setPersonalToHire() {
    this.rrhhService.getPersonalToHire().subscribe({
      next: (response: ResponseObject) => {
        this.personalToHire = response.data;
        this.pagination.total = this.personalToHire;
        setTimeout(()=>{
          this.paginationComponent.reset();
        },500);
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  addOrRemoveEmployee(employee: EmployeeResponse) {
    if (this.personalHiring[employee.id]) {
      delete this.personalHiring[employee.id];
    } else {
      this.personalHiring[employee.id] = employee;
    }
  }

  getDisabledHiring() {
    return this.getHiringNumber() < 1 || this.hiring
  }

  getHiringNumber() {
    return Object.keys(this.personalHiring).length;
  }

  showModalProfileSalary() {
    this.createProfileSalary = true;
    this.newSalary = new ProfileSalaryRequest();
  }

  closeModalProfileSalary(value: number) {
    if (value != -1) {
      this.setProfileContracts(value);
    }
    this.createProfileSalary = false;
    this.newSalary = null;
  }

  showModalDocuments(employee: EmployeeResponse) {
    this.newDocuments = employee;
    console.log(this.newDocuments);

  }

  contract() {
    this.contractEmployees = true;
    var salary = this.contractProfiles.find((c) => {
      return c.id + "" == this.selectedProfile + ""
    });
    var employees = [];
    var temp = Object.keys(this.personalHiring).map(key => ({
      ...this.personalHiring[key]
    }));
    temp.forEach((p) => {
      employees.push(p.id);
    })
    var request = {};
    request['employees'] = employees;
    request['position'] = this.selectedPosition;
    request['relationAmount'] = salary.relationAmount;
    request['proAmount'] = salary.proAmount;
    request['bonusAmount'] = salary.bonusAmount;
    request['rAguinaldo'] = salary.rAguinaldo;
    request['rBono'] = salary.rBono;
    request['rVacaciones'] = salary.rVacaciones;
    request['rIggs'] = salary.rIggs;
    request['pAguinaldo'] = salary.pAguinaldo;
    request['pBono'] = salary.pBono;
    request['pVacaciones'] = salary.pVacaciones;
    request['bAguinaldo'] = salary.bAguinaldo;
    request['bBono'] = salary.bBono;
    request['bVacaciones'] = salary.bVacaciones;
    request['type'] = salary.type;
    request['shift'] = salary.shift;
    request['payment'] = salary.payment;
    

    console.log(request);

    this.rrhhService.hireEmployees(request).subscribe({
      next: (response: ResponseObject) => {
        this.toastService.success("Contratados con exito");
        this.hiring = false;
        this.contractEmployees = false;
        this.setPersonalToHire();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
        this.contractEmployees = false;
      }
    });
  }
}
